module.exports = __webpack_public_path__ + "static/img/activity-20240423.357e108.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-20240423.png
// module id = dTZB
// module chunks = 0